module.exports = __webpack_public_path__ + "img/google-scholar.8b7ac23a.svg";